<template>
  <component v-bind="chartProps" :reload="reload" :class="reportType"/>
</template>

<script>
import { computed, defineComponent } from 'vue';

import { ReportsEnum } from '../configs/ReportsEnum';
import ChartDataProvider from '../ChartDataProvider';
import { dataProvider } from '../Injectors';

export default defineComponent({
  name: 'PrintableChart',

  provide() {
    if (this.chartSettings) {
      return {
        [dataProvider]: ChartDataProvider,
      };
    }
    return {
      context: this.context,
      reportType: this.reportType
    };
  },

  props: {
    componentName: {
      default: 'HeatmapReport',
    },
    context: {},
    report: {},
    reportType: {},
    text: {},
    reportLoading: {},

    contextFilters: {},
    player: {},
    query: {},
    staticFilters: {},
  },

  inject: {
    contextFilters: {},
    player: {},
    query: {},
    staticFilters: {},
  },

  components: {
    HeatmapReport: () =>
      import(/* webpackChunkName: "playerProfilesPitching" */ '@/modules/player-profiles/reports/HeatmapReport.vue'),
  },

  data() {
    return {
      reload: 1,
    };
  },

  computed: {
    enumKey() {
      let enumKey = `${this.context}-${this.reportType}`;
      return enumKey;
    },

    chartSettings() {
      if (ReportsEnum.hasOwnProperty(this.enumKey)) {
        return {
          ...ReportsEnum[this.enumKey],
          enabledHover: false,
        }
      }
      return false;
    },

    chartDataProviderConf() {
      return {
        key: this.enumKey,
        conf: this.chartSettings,
      };
    },

    chartProps() {
      const props = {
        chartConf: this.chartDataProviderConf,
        dynamicFilters: this.contextFilters,
        is: this.componentName,
        player: this.player,
        report: this.report,
        reportLoading: !this.player || this.reportLoading,
        // showDummyData: this.showDummyData,
        staticFilters: this.staticFilters,
        query: this.query,
        fillHeight: false,
      };

      switch (this.reportType) {
        case 'pitch-location-2':
        case 'strike-zone-2':
          props['chartComponent'] = () => import('@/components/ui/charts/StrikeZoneHmap.vue');
          break;
        default:
          break;
      }

      return props;
    },
  },

});
</script>

<style lang="scss" scoped>

</style>
